import dayjs from 'dayjs';
import { fetchAvailabilities as fetchAvailabilitiesApi } from '@api';
import { formatDateToISO8601, getTimeZone } from '@utils';

type Params = {
  appointmentBufferMinutes: number;
  stateCode: string;
  visitTypeId: string;
};

export async function fetchAvailabilities({
  appointmentBufferMinutes,
  stateCode,
  visitTypeId,
}: Params) {
  const fromDateTime = dayjs()
    .add(appointmentBufferMinutes, 'minutes')
    .toDate();
  const endOfTomorrow = dayjs(fromDateTime).add(1, 'day').endOf('day').toDate();
  const timezone = getTimeZone();

  const availabilities = await fetchAvailabilitiesApi({
    fromDateTime: formatDateToISO8601(fromDateTime),
    state: stateCode,
    timeZone: timezone,
    toDateTime: formatDateToISO8601(endOfTomorrow),
    visitTypeId: visitTypeId.toString(),
  });

  return availabilities;
}
